import React from 'react'
import { Card, Divider } from 'antd'
import { AuditOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

import { currency } from 'utils/formatting'
import { ItemRow, ItemsRow } from 'components/apps/Reports/PosShift/Detail/ItemsRow'
import SectionHeader from 'components/apps/Reports/PosShift/Detail/SectionHeader'
import HelpHint from 'components/apps/Reports/PosShift/Detail/HelpHint'
import styles from './detail.module.scss'

const RED = '#dc2626'
const YELLOW = '#ca8a04'
const GREEN = '#16a34a'

const CashReconciliation = ({ data, loading }) => {
  const { formatMessage } = useIntl()

  const closingBalance = Number(data?.closing_balance) || 0
  const cashSales = Number(data?.cash_sales) || 0
  const diff = closingBalance - cashSales

  let statusId = 'report.status_matched'
  let color = GREEN
  if (diff > 0) {
    statusId = 'report.status_more'
    color = YELLOW
  } else if (diff < 0) {
    statusId = 'report.status_less'
    color = RED
  }

  return (
    <Card
      className={styles.card}
      loading={loading}
      title={
        <SectionHeader
          icon={<AuditOutlined />}
          iconClassName={styles.iconAmber}
          title={formatMessage({ id: 'report.cash_reconciliation' })}
        />
      }
    >
      <ItemsRow>
        <ItemRow
          title={formatMessage({ id: 'report.actual_cash_counted' })}
          amount={currency(closingBalance)}
        />
        <ItemRow
          title={formatMessage({ id: 'report.expected_cash' })}
          amount={currency(cashSales)}
        />
        <Divider dashed style={{ margin: '4px 0' }} />
        <ItemRow
          title={
            <span>
              {formatMessage({ id: 'report.cash_difference' })}
              <HelpHint
                title={
                  <>
                    {formatMessage({ id: 'report.cash_reconciliation_formula' })}
                    <br />
                    {formatMessage({ id: 'report.cash_reconciliation_legend' })}
                  </>
                }
              />
            </span>
          }
          amount={`${currency(Math.abs(diff))} (${formatMessage({ id: statusId })})`}
          bold
          styleAmount={{ color }}
        />
      </ItemsRow>
    </Card>
  )
}

export default CashReconciliation
